var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5714_764)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 21C20.985 21 24 19.5 24 17.25V3C24 1.5 21 0 17.25 0C13.5 0 10.5 1.5 10.5 3V8.25C12.255 8.985 13.755 10.215 14.82 11.775C15.555 11.919 16.365 11.9985 17.25 11.9985C19.215 11.9985 20.85 11.607 22.02 10.9695C22.1861 10.8782 22.3478 10.7791 22.5045 10.6725V12.7425C22.5045 13.095 22.224 13.6425 21.3015 14.1465C20.4075 14.634 19.0365 14.9925 17.2515 14.9925C16.8945 14.9925 16.5545 14.979 16.2315 14.952C16.3515 15.445 16.4315 15.95 16.4715 16.467C16.7245 16.481 16.9845 16.488 17.2515 16.488C19.2165 16.488 20.8515 16.0965 22.0215 15.459C22.1876 15.3677 22.3493 15.2686 22.506 15.162V17.232C22.506 17.586 22.2825 18.111 21.3195 18.63C20.3715 19.14 18.9495 19.482 17.2545 19.482C16.9095 19.482 16.5755 19.468 16.2525 19.44C16.1372 19.9386 15.9822 20.4271 15.789 20.901C16.261 20.954 16.749 20.9805 17.253 20.9805L17.25 21ZM21.3 9.66C22.2225 9.156 22.503 8.6085 22.503 8.256V6.186C22.348 6.292 22.1865 6.391 22.0185 6.483C20.8515 7.1205 19.2135 7.512 17.2485 7.512C15.2835 7.512 13.6485 7.1205 12.4785 6.483C12.3124 6.39171 12.1507 6.2926 11.994 6.186V8.256C11.994 8.6085 12.2745 9.156 13.197 9.6585C14.091 10.146 15.462 10.5045 17.247 10.5045C19.032 10.5045 20.397 10.146 21.297 9.6585L21.3 9.66ZM12 3.75C12 3.318 12.1875 2.9025 12.537 2.649C12.7275 2.511 12.9345 2.373 13.098 2.298C13.5075 2.109 15.558 1.4985 17.253 1.4985C18.948 1.4985 20.418 1.839 21.408 2.298C21.594 2.3835 21.7995 2.517 21.981 2.649C22.3275 2.8995 22.506 3.312 22.506 3.7395V3.7485C22.506 4.101 22.2255 4.6485 21.303 5.1525C20.409 5.64 19.038 5.9985 17.253 5.9985C15.468 5.9985 14.103 5.6385 13.203 5.1525C12.2805 4.65 12 4.101 12 3.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 17.25C13.5 20.985 10.485 24 6.75 24C3.015 24 0 20.985 0 17.25C0 13.515 3.015 10.5 6.75 10.5C10.485 10.5 13.5 13.515 13.5 17.25ZM12 17.25C12 20.145 9.645 22.5 6.75 22.5C3.855 22.5 1.5 20.145 1.5 17.25C1.5 14.355 3.855 12 6.75 12C9.645 12 12 14.355 12 17.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5714_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsStack);
export default __webpack_public_path__ + "static/media/coins-stack.957ae005310f3d91a2f053e2f31db32b.svg";
export { ForwardRef as ReactComponent };